import { getGolaPaceKgValues, getGolaPaceLbsValues } from "../helpers"

export default (getView) =>
  ({ nextStepPath }) => ({
    ...getView({
      nextStepPath,
    }),

    init() {
      this.handleLoadingEnd = this.handleLoadingEnd.bind(this)
      this.commonInit()
    },

    // Product requirement for the formula:
    // Use maximum goal pace (5kg | 12lbs per week)
    getFirstWeekValue() {
      return this.isMetric() ? 5 : 12
    },

    handleLoadingEnd() {
      setTimeout(() => {
        window.location = nextStepPath
      }, 2000)
    },
  })
